import React from 'react';

/** Shown on the landing page while Google/LinkedIn signup completes account creation. */
export const OAuthSignupProgressOverlay: React.FC = () => (
  <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#FCFBF9]/95 backdrop-blur-sm px-6 font-space-grotesk">
    <div className="w-full max-w-md text-center">
      <div className="animate-spin h-12 w-12 border-4 border-primary-600 border-t-transparent rounded-full mx-auto mb-6" />
      <h1 className="text-xl font-semibold text-grayscale-1300 mb-2">Creating your account…</h1>
      <p className="text-sm text-grayscale-1000 leading-relaxed mb-4">
        We&apos;re finishing registration with your Google or LinkedIn profile and securing your session.
        On phones this can take a few extra seconds due to network latency.
      </p>
      <ul className="text-left text-xs text-grayscale-900 space-y-2 mx-auto max-w-xs">
        <li className="flex gap-2"><span className="text-primary-600">1.</span> Confirming your email</li>
        <li className="flex gap-2"><span className="text-primary-600">2.</span> Setting up your workspace</li>
        <li className="flex gap-2"><span className="text-primary-600">3.</span> Signing you in</li>
      </ul>
    </div>
  </div>
);
